const INIT_STATE = {
  currency: 'USDT',
};

const Currency = (state = INIT_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default Currency;
